import sanityClient from '~/shared/sanity/sanity-client'

interface SanityQueryArgs {
  queryString: string
  queryParams: { [key: string]: any }
}

interface SanityQuerySuccess {
  data: any
  error?: undefined
  meta?: { request: Request; response: Response }
}
interface SanityQueryError {
  error: {
    status: number
    data: any
  }
  data?: undefined
  meta?: { request: Request; response: Response }
}

export async function SanityQuery({
  queryString,
  queryParams,
}: SanityQueryArgs): Promise<SanityQuerySuccess | SanityQueryError> {
  try {
    const response = await sanityClient.fetch(queryString, queryParams)
    return {
      data: response,
    }
  } catch (err) {
    return {
      error: err,
    }
  }
}
